import React from 'react'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import { ListingConsumer, ListingProvider } from '../../context/ListingContext'
import InvoiceSignCertificates from '../../components/Invoice/Steps/Step6/InvoiceSignCertificates'
import { DraftInvoiceSubmitProvider, DraftInvoiceSubmitConsumer } from '../../context/DraftInvoiceSubmitContext'

const DraftSignForm = ({ currentData, isBulk, updateParentEntity, cancelDialog, updateSelectedRows }) => {
  const formClasses = formStyles()

  React.useEffect(() => {
      let url = 'etaxwebsignclient://launch'
      const link = document.createElement('a')
      link.href = url
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  return (
    <DraftInvoiceSubmitProvider invoices={isBulk ? [...currentData] : [currentData]}
                                updateSelectedRows={updateSelectedRows}
                                updateParentEntity={updateParentEntity}>
      <DraftInvoiceSubmitConsumer>
        {({ signInvoice, invoiceSubmissionLoading }) => (
          <ListingProvider entityName={'userCertificates'} reCallToGetData={12}>
            <ListingConsumer>
              {({ listingData, listingLoading, listingFinishRecall, refreshListingData }) => (
                <InvoiceSignCertificates certificates={listingData}
                                         certificatesLoading={listingLoading}
                                         invoiceSubmissionLoading={invoiceSubmissionLoading}
                                         certificatesFinishRecall={listingFinishRecall}
                                         refreshListingData={refreshListingData}
                                         cancelDialog={cancelDialog}
                                         onSubmit={signInvoice}
                                         isDraft
                                         formClasses={formClasses}
                />
              )}
            </ListingConsumer>
          </ListingProvider>
        )}
      </DraftInvoiceSubmitConsumer>
    </DraftInvoiceSubmitProvider>
  )
}

export default DraftSignForm
